import React, { FC, memo } from "react";
import { Button, Tooltip } from "@mui/material";
import { MdFilterList } from "react-icons/md";

interface FiltersButtonProps {
	onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
	// Filters are applied: a dot on the button says so.
	active?: boolean;
}

const FiltersButton: FC<FiltersButtonProps> = ({ onClick, active = false }) => {
	return (
		<Tooltip arrow title={active ? "Filters applied" : "Filter"} placement="bottom">
			<Button
				onClick={onClick}
				variant="text"
				aria-label={active ? "Filters applied" : "Filter"}
				className={"btn-outline-primary d-flex align-items-center justify-content-center d-40 mr-2 p-0 rounded-pill text-capitalize pb-filter-btn" + (active ? " is-active" : "")}>
				<MdFilterList />
				{active && <span className="pb-filter-dot" />}
			</Button>
		</Tooltip>
	);
};

export default memo(FiltersButton);
